import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";

import { BaseState } from "./types";

const state = {} as BaseState;

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
